export const FORM_LOGIN = 'login'
export const FORM_CREATE_LOAN = 'createLoan'
export const FORM_CREATE_USER = 'createUser'
export const FORM_LOAN_PAYMENT = 'loanPayment'
export const FORM_FORGOT_PASSWORD = 'forgotPassword'
export const FORM_SET_PASSWORD = 'setPassword'



// WEBPACK FOOTER //
// ./src/constants/Form.tsx